import { Directive, HostBinding, HostListener, Input } from '@angular/core'
import { ContentStackItemOptions, ContentStackService } from '../_services/content-stack.service'

@Directive({
    selector: '[fmSendProfileToDynamicPanel]',
})
export class FmSendProfileToDynamicPanelDirective {
    @Input('fmSendProfileToDynamicPanel') profileSlug: string
    @Input() fmSendProfileToDynamicPanelSource: string

    @HostBinding('class.cursor-pointer')
    get cursorPointer(): boolean {
        return !!this.profileSlug
    }

    constructor(private contentStackService: ContentStackService) {}

    @HostListener('click')
    onHostClick(): void {
        if (this.profileSlug) {
            const options: ContentStackItemOptions = {
                popIfCovered: true,
                preserveStack: false,
            }

            this.contentStackService.pushProfileToDynamicPanel(this.profileSlug, options)
        }
    }
}
